<template>
  <a-modal
    :confirmLoading="uploading"
    width="588px"
    v-model:visible="visible"
    title="导入话术"
    @ok="handleOk"
    okText="导入"
    @cancel="
      () => {
        formRef.resetFields()
        fileList = []
        errorTips = null
      }
    "
  >
    <a-form :rules="rules" ref="formRef" v-bind="layout" :model="formState" class="form">
      <a-form-item name="phraseId" label="话术分类">
        <a-tree-select
          style="width: 240px"
          placeholder="请选择话术分类"
          :tree-data="dataSourse"
          :replaceFields="{ children: 'listNode', title: 'phraseName', key: 'id', value: 'id' }"
          v-model:value="formState.phraseId"
        />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 14, offset: 4 }" style="margin-bottom: 0">
        <div class="downLoad">
          <div class="label">上传需要导入的话术</div>
          <a-button @click="downLoadTemplate" type="link">点此下载模版</a-button>
        </div>
        <p class="uploadTips">仅支持xls,xlsx格式，大小2M以内，单次上传最多50条数据。</p>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button>
            <upload-outlined></upload-outlined>
            上传文件
          </a-button>
        </a-upload>
      </a-form-item>
      <a-form-item v-if="errorTips" :wrapper-col="{ span: 14, offset: 4 }">
        <div class="errorTips">
          <CloseCircleFilled style="margin: 0 6px 3px 0; font-size: 16px" />
          <span>{{ errorTips }}</span>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { downLoadTemplate, getLeftTree, phraseClassifyImport } from '@/api/Speach/index.js'
import { UploadOutlined, CloseCircleFilled } from '@ant-design/icons-vue'
import { defineComponent, ref, reactive } from 'vue'
import { message as Message } from 'ant-design-vue'
import { findNode } from '@/utils/index'

export default defineComponent({
  name: 'Import',
  components: {
    UploadOutlined,
    CloseCircleFilled
  },
  setup(props, { emit }) {
    const formRef = ref()
    const fileList = ref([])
    const uploading = ref(false)
    const dataSourse = ref([])
    const visible = ref(false)
    const errorTips = ref(null)
    const formState = reactive({ phraseId: [] })
    const rules = {
      phraseId: [{ required: true, message: '请选择话术分类', trigger: 'change', type: 'number' }]
    }
    const showModal = () => {
      leftTree()
      visible.value = true
    }
    const handleOk = () => {
      if (fileList.value.length < 1) errorTips.value = '请导入文件'
      formRef.value.validate().then(() => {
        handleUpload()
        // visible.value = false
      })
    }
    const handleRemove = file => {
      const index = fileList.value.indexOf(file)
      const newFileList = fileList.value.slice()
      newFileList.splice(index, 1)
      fileList.value = newFileList
      errorTips.value = null
    }

    const beforeUpload = file => {
      //最大上传大小2M
      const maxSize = 2
      const fileSize = Number(file.size / 1024 / 1024)
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.')) //截取.以后的字符串
      if (fileSize > maxSize) {
        errorTips.value = '文件大小不能超过2MB，请重新上传！'
        return false
      }
      if (fileType !== '.xls' && fileType !== '.xlsx') {
        errorTips.value = '文件仅支持xls,xlsx格式，请重新上传！'
        return false
      }
      errorTips.value = null
      fileList.value = [...fileList.value, file]
      return false
    }
    const handleUpload = () => {
      const seletctData = findNode(dataSourse.value, 'listNode', node => {
        return node.id === formState.phraseId
      })
      const { id, phraseLevel, phraseName } = seletctData || {}
      const formData = new FormData()
      fileList.value.forEach(file => {
        formData.append('file', file)
      })
      formData.append('id', id)
      formData.append('phraseLevel', phraseLevel)
      formData.append('phraseName', phraseName)
      uploading.value = true
      phraseClassifyImport(formData, seletctData)
        .then((res = {}) => {
          uploading.value = false
          const { data = {} } = res
          const { message = '', success } = data
          if (!success) return Message.error(message || '导入失败')
          emit('getPageList')
          Message.success('导入成功')
          visible.value = false
          formRef.value.resetFields()
          fileList.value = []
          errorTips.value = null
        })
        .catch(() => {
          uploading.value = false
        })
    }
    //获取话术分类数据
    const leftTree = () => {
      getLeftTree().then((res = []) => {
        dataSourse.value = [...res]
      })
    }
    return {
      visible,
      formRef,
      uploading,
      fileList,
      dataSourse,
      rules,
      layout: { labelCol: { span: 4 }, wrapperCol: { span: 14 } },
      formState,
      showModal,
      handleOk,
      handleRemove,
      beforeUpload,
      handleUpload,
      errorTips,
      downLoadTemplate
    }
  }
})
</script>
<style lang="scss" scoped>
.form {
  ::v-deep(.ant-form-item) {
    margin-bottom: 16px;
  }
  .uploadTips {
    font-size: 12px;
    color: #8c8c8c;
    padding-bottom: 8px;
    margin: 0;
  }
  .downLoad {
    width: 230px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep(.ant-btn) {
      padding: 0;
      font-size: 12px;
    }
    .label {
      font-size: 14px;
      color: #333333;
    }
  }
  .errorTips {
    font-size: 12px;
    color: #ff4848;
    display: flex;
    align-items: center;
  }
}
</style>
